export const TYRES_OPS_DASHBOARD = 'dashboard';
export const TYRES_OPS_MOVEMENT = 'movements';
export const TYRES_OPS_DETAIL = 'detail';

export const TYRES_OPS_CONTRACT = 'tyre-contracts';
export const TYRES_OPS_CONTRACT_DETAIL = 'detail';